export default "__VITE_ASSET__mlA5$kHB__"